<div class="balance-dialog-backdrop" *ngIf="visible" (click)="close()">
  <section class="balance-dialog" role="dialog" aria-modal="true" aria-label="Chi tiết số dư"
    aria-labelledby="balance-dialog-title" (click)="$event.stopPropagation()">
    <h3 id="balance-dialog-title" class="balance-dialog-title">Tài khoản ngân hàng</h3>
    <div class="balance-dialog-row">
  <div class="balance-box">
  <span>Số dư tài khoản: </span>
  <strong>{{ formattedBalanceDisplay }}đ</strong>
</div>

  <div class="actions">
    <button class="balance-dialog-btn" [class.active]="showDepositQr" (click)="onDeposit()">Nạp tiền</button>
    <button class="balance-dialog-btn" [class.active]="showWithdrawForm" (click)="onWithdraw()">Rút tiền</button>
  </div>
</div>
    <!-- <div class="balance-dialog-actions">
      
    </div> -->
<div class="bank-logo-list">
          <img src="assets/BankLogo/ACB.png" alt="ACB" />
          <img src="assets/BankLogo/BIDV-01.png" alt="BIDV" />
          <img src="assets/BankLogo/SHB-01.png" alt="SHB" />
          <img src="assets/BankLogo/Vietinbank-01.png" alt="Vietinbank" />
          <img src="assets/BankLogo/VPbank-01.png" alt="VPBank" />
        </div>
    <div class="deposit-layout" *ngIf="showDepositQr">
      <div class="deposit-step" *ngIf="step === 1">
        
        <div class="deposit-title">Tạo giao dịch nạp tiền</div>

        <table class="table-transaction">
          <tr>
            <td colspan="2" class="section-title">
              💳 Thông tin giao dịch
            </td>
          </tr>
          <tr>
            <td>🆔 Mã giao dịch</td>
            <td class="name-value">{{ gettransactionCode() }}</td>
          </tr>

          <tr>
            <td>📅 Ngày</td>
            <td>{{ currentDate | date:'dd/MM/yyyy' }}</td>
          </tr>

          <tr>
            <td>💰 Số tiền (bằng số)</td>
            <td class="amount-value-number">{{ depositAmountNumber | number:'1.0-0' }}đ</td>
          </tr>

          <tr>
            <td>✍️ Số tiền (bằng chữ)</td>
            <td class="amount-value-text">{{ depositAmountText || 'một trăm nghìn đồng' }}</td>
          </tr>
        </table>

        <table class="table-deposit-input">
          <tr>
            <td colspan="2" class="section-title">  💸 Nhập số tiền nạp (vnd)</td>
          </tr>

          <td colspan="2">
            <div class="deposit-input-row">
              <input id="deposit-amount" type="text" inputmode="numeric" class="deposit-input"
                [value]="depositAmountInput" (input)="onDepositAmountInput($event)" placeholder="Nhập số tiền cần nạp"
                maxlength="12" />

              <button type="button" class="deposit-confirm-btn" (click)="confirmDeposit()"  [disabled]="!depositAmountInput">
                Nạp tiền
              </button>
            </div>
          </td>
        </table>
      </div>

      <div class="deposit-step" *ngIf="step === 2">
        <div class="deposit-title">Thanh toán</div>
        <div class="qr-layout">
          <table class="table-receiver-only">
            <tr>
              <td colspan="2" class="section-title"> 👤 Thông tin người nhận </td>
            </tr>
            <tr>
              <td>Họ tên</td> <td>{{ receiver?.name }}</td>
            </tr>
            <tr>
              <td>Số tài khoản</td> <td>{{ receiver?.account }}</td>
            </tr>
            <tr>
              <td>Ngân hàng</td> <td>{{ receiver?.bank }}</td>
            </tr>
          </table>
          <div class="qr-box">
            <img class="deposit-qr-image" [src]="depositQrUrl" />
            <div class="deposit-qr-actions">
              <button type="button" class="qr-download-btn" (click)="downloadDepositQr()"> Download </button>
            </div>
          </div>
        </div>
        <div class="deposit-result-title">Quét mã QR để thanh toán( Hiệu lực trong 4h)</div>
        <div class="deposit-result-note">  Vui lòng không đóng hộp thoại này cho đến khi hoàn thành thanh toán </div>
        <div class="deposit-step-actions">
          <button type="button" class="btn-cancel" (click)="closeDeposit()">  Hủy  </button>
          <button type="button" class="btn-success" (click)="completeDeposit()"> Hoàn thành </button>
        </div>
      </div>
    </div>

    <div class="withdraw-form" *ngIf="showWithdrawForm">
       <div class="deposit-title">Giao dịch rút tiền</div>
      <label class="required-label withdraw-label" for="withdraw-amount">Số tiền rút (vnd)</label>
      <input id="withdraw-amount" type="text" inputmode="numeric" autocomplete="off" pattern="[0-9]*"
        class="withdraw-input" [value]="withdrawAmountInput" (input)="onWithdrawAmountInput($event)"
        (keydown)="onAmountKeyDown($event)" placeholder="Nhập số tiền cần rút" maxlength="12" />

      <label class="withdraw-label required-label" for="withdraw-password">Mật khẩu rút tiền</label>
      <div class="withdraw-password-wrap">
        <input id="withdraw-password" name="withdrawPasswordBank" [type]="showWithdrawPassword ? 'text' : 'password'"
          autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false" class="withdraw-input"
          [value]="passwordBankInput" (input)="onPasswordBankInput($event)" placeholder="Nhập mật khẩu rút tiền" />
        <button type="button" class="withdraw-password-toggle" (click)="toggleWithdrawPasswordVisibility()"
          [attr.aria-label]="showWithdrawPassword ? 'Ẩn mật khẩu rút tiền' : 'Hiện mật khẩu rút tiền'"
          [attr.aria-pressed]="showWithdrawPassword">
          <svg class="withdraw-password-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7S2.5 12 2.5 12Z" fill="none" stroke="currentColor"
              stroke-width="1.8" stroke-linejoin="round" />
            <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" fill="none" stroke="currentColor"
              stroke-width="1.8" />
            <path *ngIf="!showWithdrawPassword" d="M4 4l16 16" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="withdraw-hint">Số dư hiện tại: {{ formattedBalanceDisplay }} vnd</div>
      <div class="withdraw-error" *ngIf="withdrawError">{{ withdrawError }}</div>
      <div class="withdraw-error" *ngIf="withdrawSubmitMessage && withdrawSubmitError">{{ withdrawSubmitMessage }}</div>
      <div class="withdraw-success" *ngIf="withdrawSubmitMessage && !withdrawSubmitError">{{ withdrawSubmitMessage }}
      </div>
      <button type="button" class="withdraw-submit-btn" (click)="submitWithdraw()"
        [disabled]="withdrawSubmitting || withdrawSucceeded">
        {{ withdrawSubmitting ? 'Đang gửi yêu cầu...' : (withdrawSucceeded ? 'Đã gửi' : 'Gửi') }}
      </button>
    </div>

    <div class="history-section">
      <button type="button" class="history-toggle" (click)="toggleHistoryDetails()"
        [attr.aria-expanded]="showHistoryDetails">
        <span class="history-title">Lịch sử</span>
        <span class="history-caret" [class.open]="showHistoryDetails" aria-hidden="true">▸</span>
      </button>

      <div class="history-table-wrap" *ngIf="showHistoryDetails">
        <table class="history-table">
          <thead>
            <tr>
              <th>Người nhận</th>
              <th>Ngân hàng</th>
              <th>Ngày</th>
              <th>Số tiền</th>
              <th>Trạng thái</th>
              <th>Ghi chú</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of historyPreview">
              <td>{{ item.accountName }}</td>
              <td>{{ item.bankName }} - {{ item.bankAccount }}</td>
              <td>{{ formatHistoryDate(item.createDate) }}</td>
              <td>{{ item.amount | number:'1.0-0' }}đ</td>
              <td>
                <span [ngClass]="getHistoryStatusClass(item.status)">{{ getHistoryStatusLabel(item.status) }}</span>
              </td>
              <td>{{ item.note }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</div>
